import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useMutation } from '@tanstack/react-query';
import { UpdateAdminRequest, } from '@wit-support/admin-contracts';
import { Button, Dialog, DialogContent, DialogTitle, DialogDescription, toast, } from '@wit-support/ui';
import { Actions, SubmitButton, ZodField, ZodForm } from '@wit-support/ui-forms';
import { updateAdmin } from '../api.js';
export function EditAdminDialog({ admin, onClose, onSaved }) {
    const mut = useMutation({
        mutationFn: (body) => updateAdmin(admin.id, body),
        onSuccess: () => {
            toast.success('Admin updated');
            onSaved();
        },
        onError: (err) => toast.error(err.message),
    });
    return (_jsx(Dialog, { open: true, onOpenChange: (v) => (!v ? onClose() : null), children: _jsxs(DialogContent, { children: [_jsxs(DialogTitle, { children: ["Edit ", admin.email] }), _jsx(DialogDescription, { children: "Leave fields empty to keep their current values." }), _jsxs(ZodForm, { schema: UpdateAdminRequest, defaultValues: {
                        displayName: admin.displayName,
                        role: admin.role,
                        timezone: admin.timezone ?? '',
                        telegramId: admin.telegramId ?? '',
                    }, onSubmit: (values) => {
                        const v = values;
                        const payload = {};
                        if (v.displayName && v.displayName !== admin.displayName)
                            payload.displayName = v.displayName;
                        if (v.role && v.role !== admin.role)
                            payload.role = v.role;
                        if (v.timezone && v.timezone !== admin.timezone)
                            payload.timezone = v.timezone;
                        if (v.telegramId && v.telegramId !== admin.telegramId)
                            payload.telegramId = v.telegramId;
                        mut.mutate(payload);
                    }, children: [_jsx(ZodField, { name: "displayName" }), _jsx(ZodField, { name: "role" }), _jsx(ZodField, { name: "timezone" }), _jsx(ZodField, { name: "telegramId" }), _jsxs(Actions, { children: [_jsx(Button, { type: "button", variant: "ghost", onClick: onClose, children: "Cancel" }), _jsx(SubmitButton, { pendingLabel: "Saving\u2026", children: "Save" })] })] })] }) }));
}
//# sourceMappingURL=edit-dialog.js.map